/** Uygulama geneli metinler: eylemler, durumlar, erişilebilirlik etiketleri, birimler. Hitap "siz"dir (08 §9.2). */
export const common = {
  appName: 'TicariShift',
  platformTitle: 'Platform yönetimi',
  actions: {
    cancel: 'Vazgeç',
    close: 'Kapat',
    save: 'Kaydet',
    retry: 'Tekrar dene',
    goHome: 'Ana sayfaya dön',
    copy: 'Kopyala',
    clearFilters: 'Filtreleri temizle',
    discardChanges: 'Değişiklikleri at',
    moreActions: 'Diğer eylemler',
    dismiss: 'Kapat',
    undo: 'Geri al',
    showPassword: 'Şifreyi göster',
  },
  states: {
    loading: 'Yükleniyor…',
    saving: 'Kaydediliyor…',
    copied: 'Kopyalandı',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',
  },
  a11y: {
    skipToContent: 'İçeriğe atla',
    closeDialog: 'Pencereyi kapat',
    closeNotification: 'Bildirimi kapat',
    notifications: 'Bildirimler',
    progress: 'İlerleme: yüzde {percent}',
    avatarOf: '{name} profil resmi',
  },
  unsaved: {
    title: 'Kaydedilmemiş değişiklikler silinsin mi?',
    body: 'Kapatırsanız bu formda yaptığınız değişiklikler kaydedilmez.',
  },
  confirm: {
    typeToConfirm: 'Onaylamak için {phrase} yazın.',
    phraseMismatch: 'Yazdığınız ifade eşleşmiyor. {phrase} yazın; büyük ve küçük harf fark etmez.',
    lockPhrase: 'KİLİTLE',
  },
  errorBoundary: {
    routeTitle: 'Bu sayfa açılamadı',
    routeBody: 'Sayfayı yeniden yüklemeyi deneyin. Sorun sürerse destek koduyla bize yazın.',
    blockTitle: 'Bu bölüm yüklenemedi',
    blockBody: 'Bölümü yeniden yüklemeyi deneyin.',
    supportCode: 'Destek kodu: {code}',
  },
  empty: {
    noResultsTitle: 'Bu filtrelerle kayıt yok',
    noResultsBody: 'Filtreleri değiştirin ya da temizleyin.',
    forbiddenTitle: 'Bu sayfayı görme yetkiniz yok',
    forbiddenBody: 'Şirket yöneticinizden "{permission}" yetkisini isteyin.',
  },
  units: {
    minutes: '{value} dk',
    hours: '{value} sa',
    hoursMinutes: '{hours} sa {minutes} dk',
    meters: '{value} m',
    recordCount: '{count} kayıt',
  },
  relative: {
    never: 'hiç',
    justNow: 'az önce',
    minutesAgo: '{minutes} dk önce',
    hoursAgo: '{hours} sa önce',
    yesterdayAt: 'dün {time}',
  },
  shift: {
    overnightSpan: '{day} vardiyası · {start} → {endDay} {end}',
    nextDay: '+1',
  },
  preferences: {
    theme: 'Tema',
    themeLight: 'Açık',
    themeDark: 'Koyu',
    themeSystem: 'Sistem',
    density: 'Yoğunluk',
    densityComfortable: 'Rahat',
    densityCompact: 'Kompakt',
  },
  // SMS gönderilemiyorsa nedeni (S62-c, SK-29): metinlere `{sms}` olarak yerleşir ("{sms}; davet e-postayla gider."). Platformda SMS kapalıysa
  // `off`; açık ama şirket ücretli planda değilse (deneme, Ücretsiz, ödemesi durmuş) `plan`.
  sms: {
    off: 'SMS şimdilik kapalı',
    plan: 'SMS yalnız ücretli planlarda gönderilir',
  },
  system: {
    rootMissing: 'Uygulama kök öğesi (#root) bulunamadı.',
    sessionProviderMissing: 'Oturum sağlayıcısı (SessionProvider) eksik.',
    sessionNotReady: 'Oturum hazır değil: useSession yalnız korunan rotalarda kullanılır.',
    pushUnavailable: 'Anlık bildirim bu ortamda kapalı.',
    unknownLoginStep: 'Bilinmeyen oturum açma adımı: {step}',
  },
} as const;
